






































































































































/** @format */

import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
// axios请求
import { chargeRecordList, chargingList } from '@/api/chargingpile-management/index';
import Utils from '@root/utils/common';
import * as _ from 'lodash';
import OrganizationSearch from '@/components/organization-search/index.vue';
import PlateInput from '@/components/plate-input/index.vue';
import { chargingPileBrand, createBrand } from '@/api/chargingpile-management/index';
import { CHARGINGPILE_LIST } from '../router-names';
import GoBackWithCloseTab from '@root/common/mixins/go-back-with-close-tab';
export interface IForm {
  brandName: string;
  thirdPartId: string;
}
@Component({
  name: 'ChargingBrandManagement'
})
// @Component
export default class ChargingBrandManagement extends Mixins(TableMixin, TableWidthMixin, GoBackWithCloseTab) {
  //搜索参数
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '充电优惠管理',
        location: {
          name: CHARGINGPILE_LIST
        }
      },
      {
        label: '充电品牌管理'
      }
    ];
  }

  tableLoading: boolean = false;
  tableData: any[] = []; // 表数据
  isChargBrandvisible = false;
  form = null;
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '充电品牌',
        dataIndex: 'brandName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '充电品牌ID',
        dataIndex: 'pkChargeBrandId',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '第三方标识',
        dataIndex: 'thirdPartId',
        width: 160,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        width: 260,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      }
    ];
  }

  // 生命周期初始化表单列表
  created() {
    this.fetchTableData();
    this.init();
  }
  /**
   * 请求数据列表
   */
  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { status, code, msg, data } = await chargingPileBrand({
        currPage: this.current,
        pageSize: this.pageSize
      });
      // const { data, totalNum, totalPage, currPage, pageSize } = data
      this.tableData = data;
      // this.total = totalNum - 0
      // this.current = currPage - 0
      // this.pageSize = pageSize - 0
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  init() {
    this.form = this.$form.createForm(this);
  }
  //点击搜索
  searchTable() {
    this.fetchTableData(true);
  }

  // 提交
  handleOk() {
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        console.log(values);
        this.submitOk(values);
      }
    });
  }
  async submitOk(values) {
    try {
      const { status, code } = await createBrand(values);
      this.$message.success('添加成功');
      this.isChargBrandvisible = false;
      this.searchTable();
      this.form.resetFields();
    } catch (e) {
      console.log(e);
      this.$message.error(e.msg || '添加失败');
    }
  }
  //   关闭
  handleCancel() {
    this.isChargBrandvisible = false;
    this.form.resetFields();
  }
  showAddChargBrand() {
    this.isChargBrandvisible = true;
  }
  toBack() {
    this.$router.push({
      name: CHARGINGPILE_LIST
    });
    this.goBack();
  }

  labelCol = { span: 7 };
  wrapperCol = { span: 15 };
}
